import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LegalPage from './pages/LegalPage';
import LinksPage from './pages/LinksPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

const normalizePathname = (pathname) => {
  if (!pathname) {
    return '/';
  }
  if (pathname === '/') {
    return pathname;
  }
  return pathname.replace(/\/+$/, '').toLowerCase();
};

const normalizedPath = normalizePathname(window.location.pathname);
const legalRoutes = ['/legal', '/terms', '/privacy', '/faq'];
const isLegalPage = legalRoutes.some((route) => (
  normalizedPath === route || normalizedPath.startsWith(`${route}/`)
));
const isLinksPage = normalizedPath === '/links' || normalizedPath.startsWith('/links/');

const getInitialTab = (path) => {
  if (path === '/privacy' || path.startsWith('/privacy/')) return 'privacy';
  if (path === '/faq' || path.startsWith('/faq/')) return 'faq';
  return 'terms';
};

root.render(
  <React.StrictMode>
    {isLinksPage ? <LinksPage /> : isLegalPage ? <LegalPage initialTab={getInitialTab(normalizedPath)} /> : <App />}
  </React.StrictMode>
);
